import { fromStatusCodeToGenericError, httpService, WebRequestFactory } from "@pjs/http";
import { apiConfig } from "../../../ApiConfig";

export const revokeTemporaryAccess = WebRequestFactory.createDelete<boolean, { tempAccessId: string }>({
    errorMapper: fromStatusCodeToGenericError,
    http: httpService,
    responseMapper: (response: Response) => Promise.resolve(response.status === 200),
    url: (params) => apiConfig.revokeTemporaryAccess(params.tempAccessId)
});
